import type { CarId } from "./protocol";

export const EMOTION_MAP_REQUEST_INTERVAL_MS = 100;
export const EMOTION_MAP_FIRST_OBSERVATION_MS: Record<CarId, number> = {
  car1: 75,
  car6: 49,
  car14: 15,
};

export interface EmotionMapRequestIdentity {
  carId: CarId;
  seekGeneration: number;
  requestRevision: number;
  requestedAtMs: number;
}

export const emotionMapRequestTime = (raceTimeMs: number, carId: CarId): number => Math.max(
  EMOTION_MAP_FIRST_OBSERVATION_MS[carId],
  raceTimeMs < EMOTION_MAP_REQUEST_INTERVAL_MS
    ? Math.max(0, Math.floor(raceTimeMs))
    : Math.floor(raceTimeMs / EMOTION_MAP_REQUEST_INTERVAL_MS) * EMOTION_MAP_REQUEST_INTERVAL_MS,
);

export const emotionMapResponseIsCurrent = (
  current: EmotionMapRequestIdentity,
  response: EmotionMapRequestIdentity,
): boolean => response.carId === current.carId
  && response.seekGeneration === current.seekGeneration
  && response.requestRevision === current.requestRevision
  && response.requestedAtMs === current.requestedAtMs;
